/**
 * @created        16/09/2023 - 16:09
 * @author         Nariman Palangi
 * @user           ragnarok
 * @organization
 * @project        boilerplate-vue-3
 * @file name      en.js
 * @file dir       src/locales
 */
export default {
        hello: "helsslo"
}